import { Platform } from "../constants";

import { ConstructDestinationUrl, URLVerification } from "./components/utms";
import { type PlatformDetails } from "./platform-details";
import { UtmSpendAdditionalDetails } from "./utm-spend-details";

const PLATFORM = Platform.YAHOO_DSP;

export const YahooDSPDetails: PlatformDetails = {
  northbeamDocUrl: "",
  officialDocUrl: "",
  additionalDetails: UtmSpendAdditionalDetails(PLATFORM),
};

export const YahooDSPSetup = () => (
  <>
    <ConstructDestinationUrl platform={PLATFORM} />
    <URLVerification platform={PLATFORM} />
  </>
);
